export class User {
    constructor(props) {
        Object.assign(this, props);
    }
    get isProfessional() {
        return this.profile === ClientProfile.Professional;
    }
    get isRetail() {
        return this.profile === ClientProfile.Retail;
    }
    get isAdministrator() {
        return this.role === Role.Administrator;
    }
    get isSupervisor() {
        return this.role === Role.Supervisor;
    }
    get isSeller() {
        return this.role === Role.Seller;
    }
    get isVirtual() {
        return this.role === Role.Virtual;
    }
}
export const Role = {
    Administrator: 'administrator',
    Supervisor: 'supervisor',
    Seller: 'seller',
    Virtual: 'virtual'
};
export const ClientProfile = {
    Hospitality: 'hospitality',
    Professional: 'professional',
    Retail: 'retail'
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/Model.ts
// module id = 90
// module chunks = 0